export function normalizeCurrency(currency) {
  return typeof currency === 'string' ? currency.trim() : '';
}

export function formatCurrencyAmount(value, currency, fixed = false) {
  if (value === null || value === undefined || value === '') return '';
  const numeric = Number(value);
  const amount = fixed && Number.isFinite(numeric) ? numeric.toFixed(2) : String(value);
  const code = normalizeCurrency(currency);
  return code ? `${amount} ${code}` : amount;
}

export function summarizeInvoiceTotals(invoices) {
  const totals = new Map();
  (invoices || []).forEach(invoice => {
    const code = normalizeCurrency(invoice.currency);
    const value = Number(invoice.total_amount);
    if (!Number.isFinite(value)) return;
    totals.set(code, (totals.get(code) || 0) + value);
  });
  return Array.from(totals.entries())
    .map(([code, total]) => formatCurrencyAmount(total, code, true))
    .join(' + ');
}
